import React, {useEffect, useState} from 'react';
import uploadImg from "./../../images/upload-cloud.svg"
import {Link} from "react-router-dom";
import CustomDatePicker from "../Componnets/CustomDatePicker";
import http from "../../services/api/utilities/http";
export default function DataLoader(props) {
    const [time , setTime] = useState('')
    const [loading , setLoading] = useState(false)
    const [loading1 , setLoading1] = useState(false)
    useEffect(()=> {
       let time = new Date();
        time = time.getFullYear()+'-'+time.getMonth()+'-'+time.getDay()+'T'+time.getHours()+':'+time.getMinutes()
        setTime(time)
    },[])
    // const startLoad = (now = false) => {
    //     setLoading(!now)
    //     setLoading1(now)
    //     let token = localStorage.getItem('token')
    //     axios.put('data_connector/data_pool_load/'+props.uid+'/',
    //         {
    //             "start_now":now,
    //             "datetime":now ? null : time
    //         },
    //         {
    //             headers:{
    //                 // 'Content-Type':'multipart/form-data',
    //                 Authorization : 'Bearer '+token
    //             }
    //         })
    //         .then(res => {
    //             console.log('close',res)
    //             props.getData()
    //         })
    //         .catch(err=>{
    //            console.log(err)
    //         })
    // }
    const startLoad = (now =false) => {
        console.log('tnx for log 1')
        setLoading(!now)
        setLoading1(now)
        window.dataPoolUid = props.uid
        window.intervalModal = setInterval(() => {
            props.getData()
            console.log('tnx for log')
        }, 5000)

        http.put('data_connector/data_pool_load/' + props.uid + '/',
            {
                "start_now": true,
                "datetime": null
            })
            .then(res => {
                console.log('close', res)
                props.getData()
            })
            .catch(err => {

            })
    }
    return (
        <div className="data-loader">
            <div className="mt-60">
                {/*<p className="title-text">This process will take about <span>2 Hours</span> to complete!</p>*/}
                <p style={{width:455}} className="blue-navy mt-2">You can start it right now or scedule for a precise time so we can start it for you. During this process you may want to do other works.</p>
                <div className="d-flex mt-40">
                   <div style={{width:280}}>
                       <p className="blue-navy f14">Start Immediatly</p>
                       <p className="mt-2 f12">It will need about 2 hours</p>
                       {/*<div className="btn mt-32" onClick={() => startLoad(true)}>START DATA LOADING</div>*/}
                       <div onClick={() => startLoad(true)} className={`${loading1 && 'btn-loading-small'} mt-24 btn btn-by-loading btn-active  mt-32`}>
                           <p>START DATA LOADING</p>
                           <p>START DATA LOADING</p>
                       </div>
                   </div>
                    <div style={{opacity: 0.3, pointerEvents: "none", paddingLeft:64, userSelect: "none"}} className="bl">
                        <p className="blue-navy f14">Schedule Data Loading</p>
                        <p className="mt-2 f12">We will start the job at the time you wantv</p>
                        <div className="mt-24">
                            <CustomDatePicker setTime={time => setTime(time)}/>
                        </div>
                        <div onClick={() => startLoad()} className={`${loading && 'btn-loading-small'} mt-24 btn btn-by-loading btn-active btn-outline mr-32`}>
                            <p>SET SCHEDULE</p>
                            <p>SET SCHEDULE</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
